import { GanttAccessRightsEnum, MemberTypesEnum } from '@thinknet-gmbh/platform-common';

interface IGanttAccess {
  ganttId: string;
  accessRight: GanttAccessRightsEnum;
}

export interface IMemberContext {
  ganttId?: string;
  currentMemberId: string;
  type: MemberTypesEnum;
  ganttsAccess?: IGanttAccess[];
}

export const INITIAL_MEMBER: IMemberContext = {
  ganttId: '',
  currentMemberId: '',
  type: MemberTypesEnum.INTERNAL,
  ganttsAccess: [],
};
